import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import React from 'react';

const CustomTooltip = ({ children, ...props }: TooltipProps) => {
  return (
    <Tooltip {...props} enterTouchDelay={0} TransitionProps={{ timeout: { enter: 0, exit: 0 } }}>
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
